export default 'https://api.giztix.com';
// export default 'https://demoapi.giztix.com';